module.exports = __webpack_public_path__ + "img/sand-rock-big-12.354b019f.png";